































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { TextField } from '@/components/atoms';
import CoinsIcon from '@/components/icons/Coins.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ExternalLink from '@/components/icons/ExternalLink.vue';
import CampaignSettingsExample from '@/componentsV2/organisms/CampaignSettingsExample/CampaignSettingsExample.vue';
import HowManyCoinsShouldIgive from '@/componentsV2/molecules/HowManyCoinsShouldIgive/HowManyCoinsShouldIgive.vue';
import Close from '@/components/icons/Close.vue';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    FilledButton,
    GhostButton,
    ExternalLink,
    TextField,
    CoinsIcon,
    CampaignSettingsExample,
    HowManyCoinsShouldIgive,
    Close
  }
})
export default class OfferCreationStep1 extends Vue {
  @Prop(Number) coinsPerCustomer!: number;
  @Prop({ default: false }) loading?: boolean;

  coins = this.coinsPerCustomer ? String(this.coinsPerCustomer) : null;
  placeholder = '10';

  howCoinsPageOpened = false;

  get coinsPreview() {
    if (this.coins && Number(this.coins) >= 0) {
      return this.coins;
    }

    return this.placeholder;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get customerImportV2() {
    return this.flags.includes('customer-import-v2');
  }

  mounted() {
    const coinsField = this.$refs.coins as any;

    coinsField.$refs.input.focus();
  }

  howManyCoinsMouseOver() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Set up your invitation campaign modal (Step 1)`,
      eventAction: 'click',
      eventLabel: `Mouse over on "How many Coins should I give?" link`
    });
  }

  handleSubmit() {
    const { clickedCTA } = this.$route.query;

    this.$analytics({
      eventCategory: `Import Customers Modals | Set up your invitation campaign modal (Step 1)`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Review campaign" button${
        clickedCTA ? ' when user is from banner' : ''
      }`
    });

    this.$emit('submit', {
      coins: this.coins,
      service: 'getElegibleCustomers'
    });
  }
}
